import { atom, useRecoilValue } from "recoil";
import { IProducerCodes, SelectedRows, IOfficeData } from "../types";

export const producerCodeAddState = atom({
  key: "producerCodeAddState ",
  default: false,
});

export const prodCodeAddState = atom({
  key: "prodCodeAddState",
  default: false,
});

export const prodCodeEditState = atom({
  key: "prodCodeEditState",
  default: false,
});

export const producerCodeShowState = atom({
  key: "producerCodeShowState",
  default: false,
});

export const rowForEditProdCode = atom<IProducerCodes | undefined>({
  key: "rowForEditProdCode",
  default: undefined,
});

export const producerCodeViewData = atom({
  key: "producerCodeViewData",
  default: [],
});

export const selectedRowsProducerCode = atom({
  key: "selectedRowsProducerCode",
  default: [],
});

export const producerCodeMastercarrierId = atom({
  key: "producerCodeMastercarrierId",
  default: undefined,
});
export const defaultDistChannelState = atom({
  key: "defaultDistChannelState",
  default: "",
});
export const prodCodeCarrierName = atom({
  key: "prodCodeCarrierName",
  default: undefined,
});

export const prodCodeModalShowState = atom({
  key: "prodCodeModalShowState",
  default: false,
});

export const prodCodeModalRowData = atom({
  key: "prodCodeModalRowData",
  default: [],
});

export const selectedRowsProdCode = atom<SelectedRows | undefined>({
  key: "selectedRowsProdCode",
  default: undefined,
});

export const defaultProdCodeSearchParams = {
  CarrierName: [],
  OfficeName: [],
  OfficeCode: [],
  State: [],
  Status: [],
  ProducerCode: "",
  MAProducerCode: "",
  IsFranchise: false,
  IsConfie: false,
  AcquisitionName: "",
  carrierProducerCodes: null,
  BillingId: null,
  BillingName: "",
  DistributionChannelId: null as number | null,
  DistributionChannelName: null as { label: string; value: number } | null,

  //for filters fields
  selectedFranchiseConfie: null as { label: string; value: number } | null,
  selectedState: [],
  selectedCarrier: [],
  selectedOffice: [],
  selectedStatus: [],
  selectedProducerCode: "",
  selectedMaProducerCode: "",
  selectedAcquisitionName: "",
  selectedCarrierName: undefined,
  selectedChannel: null,

  //for view setting filter
  SelectedCarrier: null,
};
export const searchDataProducerCode = atom({
  key: "searchDataProducerCode",
  default: defaultProdCodeSearchParams,
});

export const exportsData = atom({
  key: "exportsData",
  default: defaultProdCodeSearchParams,
});

export const prodCodeFilterValues = atom({
  key: "prodCodeFilterValues",
  default: defaultProdCodeSearchParams,
});

export const franchiseFilterState = atom({
  key: "franchiseFilterState",
  default: false,
});

export const prodCodeFilterOpen = atom({
  key: "prodCodeFilterOpen",
  default: false,
});

export const searchedProducerCodeTableData = atom({
  key: "searchedProducerCodeTableData",
  default: [],
});

export const prodCodeMassUpload = atom({
  key: "prodCodeMassUpload",
  default: false,
});

export const isProducerCodeFilterOpen = atom({
  key: "isProducerCodeFilterOpen",
  default: false,
});

export const isResetStatus = atom({
  key: "isResetStatus",
  default: false,
});

export const downloadLoading = atom({
  key: "downloadLoading",
  default: false,
});

export const isClearFilter = atom({
  key: "isClearFilter",
  default: false,
});

export const prodCodeId = atom<number | null>({
  key: "prodCodeId",
  default: null,
});
export const officeToProdCodeId = atom({
  key: "officeToProdCodeId",
  default: null,
});
export const officeShowStateModal = atom({
  key: "officeShowStateModal",
  default: false,
});
export const ofcToProducerCodeId = atom({
  key: "ofcToProducerCodeId",
  default: "",
});

export const franchiseType = atom({
  key: "franchiseType",
  default: undefined,
});
export const oncloseOfficeToProdCodeModal = atom({
  key: "oncloseOfficeToProdCodeModal",
  default: false,
});

export const isRefetchExpandedModal = atom({
  key: "isRefetchExpandedModal",
  default: false,
});

export const franchiseCheckBox = atom({
  key: "franchiseCheckBox",
  default: false,
});

export const fromViewModal = atom({
  key: "fromViewModal",
  default: false,
});

export const fromRecentActivity = atom({
  key: "fromRecentActivity",
  default: false,
});

export const fromRedirection = atom({
  key: "fromRedirection",
  default: false,
});

export const isShowFromEmployee = atom({
  key: "isShowFromEmployee",
  default: false,
});

export const officeData = atom<IOfficeData | undefined>({
  key: "officeData",
  default: undefined,
});
